import { plainToClass } from "class-transformer";
import { FormatDate, GetDateFromString } from "../../scripts/date-functions";
import { FileTimestamp } from "./date-updated-section.entities";

export class DateUpdatedSection {
    constructor(dataJson: any) {

        $(() => {

            let fileTimestamps: FileTimestamp[] = plainToClass(FileTimestamp, <FileTimestamp[]>dataJson);

            if (!fileTimestamps) {
                return;
            }

            fileTimestamps.forEach((file: FileTimestamp) => {
                let date: Date = GetDateFromString(file.FileDate, "hyphens-year-month-day");
                if (file.Name == "REVERSE-LC") { $('#last-update-date-rvlc').html(FormatDate(date)); }
            });

            $('#date-updated-section').removeClass('invisible');

        });

    }
}